// import React, { useState } from "react";
// import {
// 	Sheet,
// 	SheetContent,
// 	SheetDescription,
// 	SheetHeader,
// 	SheetTitle,
// } from "../components/ui/sheet";
// import {
// 	Table,
// 	TableBody,
// 	TableCell,
// 	TableHead,
// 	TableHeader,
// 	TableRow,
// 	TableCaption,
// } from "../components/ui/table";
// import { Button } from "../components/ui/button";
// import { ClipLoader } from "react-spinners";
// import { useGetAllTradingPartners } from "../migration-api/api-hooks/trading-partners";
// import { format, isValid, parseISO } from "date-fns";
// import InviteTradingPartner from "./Invitetradingpartner";
// import { ScrollArea } from "../components/ui/scroll-area";

// const TradingPartnersPopover = ({ open, onOpenChange, client }) => {
// 	const [showInviteForm, setShowInviteForm] = useState(false);
// 	const [currentPage, setCurrentPage] = useState(1);

// 	// Fetch trading partners for this client
// 	const {
// 		data: tradingPartnersResponse,
// 		isLoading,
// 		error,
// 	} = useGetAllTradingPartners(
// 		{
// 			page: currentPage,
// 			size: 10,
// 			clientId: client?.id,
// 		},
// 		{
// 			enabled: open && !!client?.id,
// 		},
// 	);

// 	const tradingPartners = tradingPartnersResponse?.data || [];
// 	const pagination = tradingPartnersResponse?.pagination || {
// 		page: 1,
// 		size: 10,
// 		total: 0,
// 		totalPages: 1,
// 	};

// 	// Format date helper
// 	const handleDate = (date) => {
// 		if (date == null) return "N/A";
// 		const validDate = parseISO(date, "yyyy-MM-dd", new Date());
// 		if (isValid(validDate))
// 			return format(new Date(date), "yyyy-MM-dd hh:mm:ss");
// 		return "N/A";
// 	};

// 	const handleInviteSuccess = () => {
// 		setShowInviteForm(false);
// 	};

// 	return (
// 		<>
// 			<Sheet open={open} onOpenChange={onOpenChange}>
// 				<SheetContent className="sm:max-w-[700px] overflow-y-auto">
// 					<SheetHeader>
// 						<SheetTitle>Trading Partners - {client?.clientName}</SheetTitle>
// 						<SheetDescription>
// 							View and manage trading partners for this client
// 						</SheetDescription>
// 					</SheetHeader>

// 					<div className="mt-6 space-y-4">
// 						{/* Add Trading Partner Button */}
// 						<div className="flex justify-end">
// 							<Button variant="outline" onClick={() => setShowInviteForm(true)}>
// 								+ Add Trading Partner
// 							</Button>
// 						</div>

// 						{/* Trading Partners List */}
// 						<div className="border rounded-md">
// 							<ScrollArea className="h-[500px]">
// 								<Table>
// 									<TableCaption>
// 										{pagination.total > 0
// 											? `Showing ${tradingPartners.length} of ${pagination.total} trading partner(s)`
// 											: "No trading partners found"}
// 									</TableCaption>
// 									<TableHeader>
// 										<TableRow>
// 											<TableHead>Name</TableHead>
// 											<TableHead>Email</TableHead>
// 											<TableHead>Location</TableHead>
// 											<TableHead>Date Added</TableHead>
// 										</TableRow>
// 									</TableHeader>
// 									<TableBody>
// 										{isLoading ? (
// 											<TableRow>
// 												<TableCell colSpan={4}>
// 													<div className="h-[20vh] flex items-center justify-center">
// 														<ClipLoader />
// 													</div>
// 												</TableCell>
// 											</TableRow>
// 										) : error ? (
// 											<TableRow>
// 												<TableCell
// 													colSpan={4}
// 													className="text-center text-red-500 h-[20vh]"
// 												>
// 													Failed to load trading partners
// 												</TableCell>
// 											</TableRow>
// 										) : tradingPartners.length === 0 ? (
// 											<TableRow>
// 												<TableCell
// 													colSpan={4}
// 													className="text-center text-gray-500 h-[20vh]"
// 												>
// 													No trading partners found for this client
// 												</TableCell>
// 											</TableRow>
// 										) : (
// 											tradingPartners.map((partner) => (
// 												<TableRow key={partner.id}>
// 													<TableCell className="font-medium">
// 														{partner.firstName} {partner.lastName}
// 													</TableCell>
// 													<TableCell>{partner.email}</TableCell>
// 													<TableCell>
// 														{partner.location || "N/A"}
// 													</TableCell>
// 													<TableCell>
// 														{handleDate(partner.createdAt)}
// 													</TableCell>
// 												</TableRow>
// 											))
// 										)}
// 									</TableBody>
// 								</Table>
// 							</ScrollArea>
// 						</div>
// 					</div>
// 				</SheetContent>
// 			</Sheet>

// 			{/* Invite Trading Partner Sheet */}
// 			<Sheet open={showInviteForm} onOpenChange={setShowInviteForm}>
// 				<SheetContent className="sm:max-w-[500px] overflow-y-auto">
// 					<SheetHeader>
// 						<SheetTitle>Invite Trading Partner</SheetTitle>
// 						<SheetDescription>
// 							Add a new trading partner for {client?.clientName}
// 						</SheetDescription>
// 					</SheetHeader>
// 					<InviteTradingPartner client={client} onSuccess={handleInviteSuccess} />
// 				</SheetContent>
// 			</Sheet>
// 		</>
// 	);
// };

// export default TradingPartnersPopover;




// import React, { useState } from "react";
// import {
// 	Sheet,
// 	SheetContent,
// 	SheetDescription,
// 	SheetHeader,
// 	SheetTitle,
// } from "../components/ui/sheet";
// import {
// 	Table,
// 	TableBody,
// 	TableCell,
// 	TableHead,
// 	TableHeader,
// 	TableRow,
// 	TableCaption,
// } from "../components/ui/table";
// import { Button } from "../components/ui/button";
// import { ClipLoader } from "react-spinners";
// import { useGetAllTradingPartners } from "../migration-api/api-hooks/trading-partners";
// import { format, isValid, parseISO } from "date-fns";
// import InviteTradingPartner from "./Invitetradingpartner";
// import EditTradingPartnerPermissions from "./Edittradingpartnerpermissions";
// import { ScrollArea } from "../components/ui/scroll-area";

// const TradingPartnersPopover = ({ open, onOpenChange, client }) => {
// 	const [showInviteForm, setShowInviteForm] = useState(false);
// 	const [showEditForm, setShowEditForm] = useState(false);
// 	const [selectedPartner, setSelectedPartner] = useState(null);
// 	const [currentPage, setCurrentPage] = useState(1);

// 	// Fetch trading partners for this client
// 	const {
// 		data: tradingPartnersResponse,
// 		isLoading,
// 		error,
//         refetch,
// 	} = useGetAllTradingPartners(
// 		{
// 			page: currentPage,
// 			size: 10,
// 			clientId: client?.id,
// 		},
// 		{
// 			enabled: !!client?.id,
// 		},
// 	);

// 	const tradingPartners = tradingPartnersResponse?.data || [];
// 	const pagination = tradingPartnersResponse?.pagination || {
// 		page: 1,
// 		size: 10,
// 		total: 0,
// 		totalPages: 1,
// 	};
//     const paginationTotal = tradingPartners.length;

// 	// Format date helper
// 	const handleDate = (date) => {
// 		if (date == null) return "N/A";
// 		const validDate = parseISO(date, "yyyy-MM-dd", new Date());
// 		if (isValid(validDate))
// 			return format(new Date(date), "yyyy-MM-dd hh:mm:ss");
// 		return "N/A";
// 	};

// 	const handleInviteSuccess = () => {
// 		setShowInviteForm(false);
// 	};

// 	const handleEditSuccess = () => {
// 		setShowEditForm(false);
// 		setSelectedPartner(null);
// 	};

// 	const handleEditClick = (partner) => {
// 		setSelectedPartner(partner);
// 		setShowEditForm(true);
// 	};

// 	return (
// 		<>
// 			<Sheet open={open} onOpenChange={onOpenChange}>
// 				<SheetContent className="sm:max-w-[700px] overflow-y-auto">
// 					<SheetHeader>
// 						<SheetTitle>Trading Partners - {client?.clientName}</SheetTitle>
// 						<SheetDescription>
// 							View and manage trading partners for this client
// 						</SheetDescription>
// 					</SheetHeader>

// 					<div className="mt-6 space-y-4">
// 						{/* Add Trading Partner Button */}
// 						<div className="flex justify-end">
// 							<Button variant="outline" onClick={() => setShowInviteForm(true)}>
// 								+ Add Trading Partner
// 							</Button>
// 						</div>

// 						{/* Trading Partners List */}
// 						<div className="border rounded-md">
// 							<ScrollArea className="h-[500px]">
// 								<Table>
// 									<TableCaption>
// 										{paginationTotal > 0
// 											? `Showing ${tradingPartners.length} of ${paginationTotal} trading partner(s)`
// 											: "No trading partners found"}
// 									</TableCaption>
// 									<TableHeader>
// 										<TableRow>
// 											<TableHead>Name</TableHead>
// 											<TableHead>Email</TableHead>
// 											<TableHead>Location</TableHead>
// 											<TableHead>Date Added</TableHead>
// 											<TableHead className="text-right">Actions</TableHead>
// 										</TableRow>
// 									</TableHeader>
// 									<TableBody>
// 										{isLoading ? (
// 											<TableRow>
// 												<TableCell colSpan={5}>
// 													<div className="h-[20vh] flex items-center justify-center">
// 														<ClipLoader />
// 													</div>
// 												</TableCell>
// 											</TableRow>
// 										) : error ? (
// 											<TableRow>
// 												<TableCell
// 													colSpan={5}
// 													className="text-center text-red-500 h-[20vh]"
// 												>
// 													Failed to load trading partners
// 												</TableCell>
// 											</TableRow>
// 										) : tradingPartners.length === 0 ? (
// 											<TableRow>
// 												<TableCell
// 													colSpan={5}
// 													className="text-center text-gray-500 h-[20vh]"
// 												>
// 													No trading partners found for this client
// 												</TableCell>
// 											</TableRow>
// 										) : (
// 											tradingPartners.map((partner) => (
// 												<TableRow key={partner.id}>
// 													<TableCell className="font-medium">
// 														{partner.firstName} {partner.lastName}
// 													</TableCell>
// 													<TableCell>{partner.email}</TableCell>
// 													<TableCell>
// 														{partner.location || "N/A"}
// 													</TableCell>
// 													<TableCell>
// 														{handleDate(partner.createdAt)}
// 													</TableCell>
// 													<TableCell className="text-right">
// 														<Button
// 															variant="link"
// 															onClick={() => handleEditClick(partner)}
// 														>
// 															Edit Permissions
// 														</Button>
// 													</TableCell>
// 												</TableRow>
// 											))
// 										)}
// 									</TableBody>
// 								</Table>
// 							</ScrollArea>
// 						</div>
// 					</div>
// 				</SheetContent>
// 			</Sheet>

// 			{/* Invite Trading Partner Sheet */}
// 			<Sheet open={showInviteForm} onOpenChange={setShowInviteForm}>
// 				<SheetContent className="sm:max-w-[500px] overflow-y-auto">
// 					<SheetHeader>
// 						<SheetTitle>Invite Trading Partner</SheetTitle>
// 						<SheetDescription>
// 							Add a new trading partner for {client?.clientName}
// 						</SheetDescription>
// 					</SheetHeader>
// 					<InviteTradingPartner client={client} onSuccess={() => {refetch(); handleInviteSuccess();}} />
// 				</SheetContent>
// 			</Sheet>

// 			{/* Edit Trading Partner Permissions Sheet */}
// 			<Sheet open={showEditForm} onOpenChange={setShowEditForm}>
// 				<SheetContent className="sm:max-w-[500px] overflow-y-auto">
// 					<SheetHeader>
// 						<SheetTitle>Edit Permissions</SheetTitle>
// 						<SheetDescription>
// 							Update permissions for {selectedPartner?.firstName}{" "}
// 							{selectedPartner?.lastName}
// 						</SheetDescription>
// 					</SheetHeader>
// 					{selectedPartner && (
// 						<EditTradingPartnerPermissions
// 							partner={selectedPartner}
// 							client={client}
// 							onSuccess={() => {refetch(); handleEditSuccess();}}
// 						/>
// 					)}
// 				</SheetContent>
// 			</Sheet>
// 		</>
// 	);
// };

// export default TradingPartnersPopover;



import React, { useState } from "react";
import {
	Sheet,
	SheetContent,
	SheetDescription,
	SheetHeader,
	SheetTitle,
} from "../components/ui/sheet";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
	TableCaption,
} from "../components/ui/table";
import { Button } from "../components/ui/button";
import { ClipLoader } from "react-spinners";
import { useGetAllTradingPartners } from "../migration-api/api-hooks/trading-partners";
import { format, isValid, parseISO } from "date-fns";
import InviteTradingPartner from "./Invitetradingpartner";
import EditTradingPartnerPermissions from "./Edittradingpartnerpermissions";
import { ScrollArea } from "../components/ui/scroll-area";
import useAuth from "../hooks/useAuth";

const normalizeTradingPartners = (data = [], auth) => {
	if (!Array.isArray(data) || data.length === 0) {
		return { partners: [], isSuperAdmin: false };
	}
	const isClientShape = data[0]?.partners !== undefined;
	if (isClientShape) {
		return {
			partners: data.flatMap((group) => group.partners ?? []),
			isSuperAdmin: auth?.user?.role === "SUPER_ADMIN",
		};
	}
	return { partners: data, isSuperAdmin: auth?.user?.role === "SUPER_ADMIN" };
};

const TradingPartnersPopover = ({ open, onOpenChange, client }) => {
	const [showInviteForm, setShowInviteForm] = useState(false);
	const [showEditForm, setShowEditForm] = useState(false);
	const [selectedPartner, setSelectedPartner] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);

    const { auth } = useAuth();

	const {
		data: tradingPartnersResponse,
		isLoading,
		error,
		refetch,
	} = useGetAllTradingPartners(
		{
			page: currentPage,
			size: 10,
			clientId: client?.id,
		},
		{
			enabled: !!client?.id,
		},
	);

	const { partners: tradingPartners, isSuperAdmin } = normalizeTradingPartners(
		tradingPartnersResponse?.data, auth
	);

	const handleDate = (date) => {
		if (date == null) return "N/A";
		const validDate = parseISO(date, "yyyy-MM-dd", new Date());
		if (isValid(validDate))
			return format(new Date(date), "yyyy-MM-dd hh:mm:ss");
		return "N/A";
	};

	const handleInviteSuccess = () => setShowInviteForm(false);

	const handleEditSuccess = () => {
		setShowEditForm(false);
		setSelectedPartner(null);
	};

	const handleEditClick = (partner) => {
		setSelectedPartner(partner);
		setShowEditForm(true);
	};

	const colSpan = isSuperAdmin ? 6 : 5;

	return (
		<>
			<Sheet open={open} onOpenChange={onOpenChange}>
				<SheetContent className="sm:max-w-[700px] overflow-y-auto">
					<SheetHeader>
						<SheetTitle>Trading Partners - {client?.clientName}</SheetTitle>
						<SheetDescription>
							View and manage trading partners for this client
						</SheetDescription>
					</SheetHeader>

					<div className="mt-6 space-y-4">
						<div className="flex justify-end">
							<Button variant="outline" onClick={() => setShowInviteForm(true)}>
								+ Add Trading Partner
							</Button>
						</div>

						<div className="border rounded-md">
							<ScrollArea className="h-[500px]">
								{/*
									The Table component wraps in overflow-auto internally.
									We pass w-full here and use max-w-0 + truncate per column
									to contain overflow without needing table-fixed on the wrapper.
								*/}
								<Table className="w-full">
									<TableCaption>
										{tradingPartners.length > 0
											? `Showing ${tradingPartners.length} trading partner(s)`
											: "No trading partners found"}
									</TableCaption>
									<TableHeader>
										<TableRow>
											{/* w-[X%] on headers guides proportional column sizing */}
											<TableHead className="w-[18%]">Name</TableHead>
											<TableHead className="w-[22%]">Email</TableHead>
											{isSuperAdmin && (
												<TableHead className="w-[16%]">Client</TableHead>
											)}
											<TableHead className="w-[14%]">Location</TableHead>
											{/* Date and Actions get fixed widths so they never wrap */}
											<TableHead className="w-[18%]">Date Added</TableHead>
											<TableHead className="w-[12%] text-right">
												Actions
											</TableHead>
										</TableRow>
									</TableHeader>
									<TableBody>
										{isLoading ? (
											<TableRow>
												<TableCell colSpan={colSpan}>
													<div className="h-[20vh] flex items-center justify-center">
														<ClipLoader />
													</div>
												</TableCell>
											</TableRow>
										) : error ? (
											<TableRow>
												<TableCell
													colSpan={colSpan}
													className="text-center text-red-500 h-[20vh]"
												>
													Failed to load trading partners
												</TableCell>
											</TableRow>
										) : tradingPartners.length === 0 ? (
											<TableRow>
												<TableCell
													colSpan={colSpan}
													className="text-center text-gray-500 h-[20vh]"
												>
													No trading partners found for this client
												</TableCell>
											</TableRow>
										) : (
											tradingPartners.map((partner) => (
												<TableRow key={partner.id}>
													{/*
														max-w-0 is the trick — it gives truncate
														a boundary to work against inside a table cell.
														Without it, the cell just expands and truncate
														never fires.
													*/}

													{/* Name */}
													<TableCell className="max-w-0">
														<p
															className="truncate font-medium text-sm"
															title={`${partner.firstName} ${partner.lastName}`}
														>
															{partner.firstName} {partner.lastName}
														</p>
													</TableCell>

													{/* Email */}
													<TableCell className="max-w-0">
														<p
															className="truncate text-sm text-muted-foreground"
															title={partner.email}
														>
															{partner.email}
														</p>
													</TableCell>

													{/* Client — SuperAdmin only */}
													{isSuperAdmin && (
														<TableCell className="max-w-0">
															<span
																className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10 max-w-full truncate"
																title={partner.clientName ?? "N/A"}
															>
																{partner.clientName ?? "N/A"}
															</span>
														</TableCell>
													)}

													{/* Location */}
													<TableCell className="max-w-0">
														<p
															className="truncate text-sm"
															title={partner.location || "N/A"}
														>
															{partner.location || "N/A"}
														</p>
													</TableCell>

													{/* Date — whitespace-nowrap, never truncate */}
													<TableCell>
														<p className="text-sm text-muted-foreground whitespace-nowrap">
															{handleDate(partner.createdAt)}
														</p>
													</TableCell>

													{/* Actions — always full, pinned right */}
													<TableCell className="text-right">
														<Button
															variant="link"
															className="h-auto p-0 text-sm whitespace-nowrap"
															onClick={() => handleEditClick(partner)}
														>
															Edit Permissions
														</Button>
													</TableCell>
												</TableRow>
											))
										)}
									</TableBody>
								</Table>
							</ScrollArea>
						</div>
					</div>
				</SheetContent>
			</Sheet>

			<Sheet open={showInviteForm} onOpenChange={setShowInviteForm}>
				<SheetContent className="sm:max-w-[500px] overflow-y-auto">
					<SheetHeader>
						<SheetTitle>Invite Trading Partner</SheetTitle>
						<SheetDescription>
							Add a new trading partner for {client?.clientName}
						</SheetDescription>
					</SheetHeader>
					<InviteTradingPartner
						client={client}
						onSuccess={() => { refetch(); handleInviteSuccess(); }}
					/>
				</SheetContent>
			</Sheet>

			<Sheet open={showEditForm} onOpenChange={setShowEditForm}>
				<SheetContent className="sm:max-w-[500px] overflow-y-auto">
					<SheetHeader>
						<SheetTitle>Edit Permissions</SheetTitle>
						<SheetDescription>
							Update permissions for {selectedPartner?.firstName}{" "}
							{selectedPartner?.lastName}
						</SheetDescription>
					</SheetHeader>
					{selectedPartner && (
						<EditTradingPartnerPermissions
							partner={selectedPartner}
							client={client}
							onSuccess={() => { refetch(); handleEditSuccess(); }}
						/>
					)}
				</SheetContent>
			</Sheet>
		</>
	);
};

export default TradingPartnersPopover;